import b from 'b_';
import React from 'react';

import { SimpleCallback } from '../../../typings';
//@ts-ignore
import Link from '../../link/link';
import { LINK_COMPONENTS } from '../../wizard/typings';

import './hint__link.scss';

export interface LinkProps {
    component: LINK_COMPONENTS;
    title: string;
    url?: string;
    onClick: SimpleCallback;
}

export const HintLink = ({ component, title, url, ...linkProps }: LinkProps) => (
    <Link mix={b('hint', 'link', { component })} pseudo={!url} to={url} {...linkProps}>
        {title}
    </Link>
);

export default HintLink;
